/**
 * react-query mutation hook for the ad-hoc validation endpoint (TASK-159 / AV-01).
 *
 * Returns the standard mutation surface (`mutate`, `mutateAsync`, `data`,
 * `isPending` / `isLoading`, `error`, `reset`) so the consumer can drive both
 * the "Zkontrolovat znovu" button in the record detail panel and the
 * preflight check inside ProposalForm's save handler.
 *
 * Closure-captures `ky` (per MEMORY: useOkapiKy returns an unstable instance
 * and must NOT appear in dependency arrays).
 */
import { useMutation } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { validateRecord, validateRecordSample } from '../api/validationService';
export var useValidateRecord = function (options) {
    if (options === void 0) { options = {}; }
    var ky = useOkapiKy();
    return useMutation(function (req) { return validateRecord(ky, req); }, {
        onSuccess: options.onSuccess,
        onError: options.onError,
    });
};
/**
 * CZNA-328 — drives the MARC Checker corpus-sample mode. Same surface as
 * {@link useValidateRecord} but resolves to a {@link ValidationSampleResult}.
 * Closure-captures `ky` (MEMORY: never in deps).
 */
export var useValidateRecordSample = function (options) {
    if (options === void 0) { options = {}; }
    var ky = useOkapiKy();
    return useMutation(function (req) { return validateRecordSample(ky, req); }, {
        onSuccess: options.onSuccess,
        onError: options.onError,
    });
};
export default useValidateRecord;
